import api from "./api";

const analytics = {
    getDataAnalytics(tab, query) {
        return api.get(`/analytics/${tab}${query}`);
    },
};

export default analytics;
